import Vue from 'vue/dist/vue.js'
import firebase from 'firebase'
import { userRef, eventsRef } from '../firebase'
import moment from 'moment-timezone'
import mapboxgl from 'mapbox-gl'
import polyline from '@mapbox/polyline'
import _ from 'lodash'
import { store } from '../store/store'
var turf = require('@turf/turf')
import { isRaceEnded } from './utils'
import { popupVue } from './popUp'
import axios from 'axios'

mapboxgl.accessToken = 'pk.eyJ1IjoibWlra29hdGEiLCJhIjoiY2l5Y3V5czBjMDA4ZzJ3cXBibXZhaDkzciJ9.F-rRrrNLnB0MfKtcosgmxA';

const mapInteractionHandlers = [
  'scrollZoom', 'dragPan', 'touchZoomRotate', 'dragRotate', 'keyboard', 'boxZoom', 'doubleClickZoom'
]

var pepEditingEnabled = false
var routing = null
var map = null
var selectedMarkerDiv = null
var markers = {}
var navigationControl = null
var radiusObjects = {}
var popup = null
var sources = {
  distanceLabels: { // white distance markers on the route
    "type": "FeatureCollection",
    "features": []
  },
  unitLabels: { // white distance markers on the route
    "type": "FeatureCollection",
    "features": []
  },
  distanceMarkers: { // white distance markers on the route
    "type": "FeatureCollection",
    "features": []
  },
  route: {
    "type": "FeatureCollection",
    "features": [{
      "type": "Feature",
      "geometry": {
        "type": "LineString",
        "coordinates": []
      }
    }]
  },
  start: {
    "type": "FeatureCollection",
    "features": [{
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": []
      }
    }]
  },
  finish: {
    "type": "FeatureCollection",
    "features": [{
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": []
      }
    }]
  },
  pepRadius: {
    "type": "FeatureCollection",
    "features": []
  },
}

class MapManager {

 static removeRouteClickListener() {
   map.off('click', 'route', this.onMapClick)
 }

 static disableInteraction() {
   console.log('disableInteraction')
   for (let handler of mapInteractionHandlers) {
     map[handler].disable()
    }

   if(navigationControl) {
     console.log('removing navigation', navigationControl)
     map.removeControl(navigationControl)
     navigationControl = null
   }
 }

 static clearMarkers() {
   console.log("Clearing markers")
   if(markers) {
     for(var key in markers) {
       if(markers.hasOwnProperty(key)) {
         markers[key].remove()
       }
     }
   }
 }

 static clearSelectedMarker() {
   if (selectedMarkerDiv !== null) {
      selectedMarkerDiv.classList.remove('runner-editable')
      selectedMarkerDiv.classList.add('runner')
      selectedMarkerDiv = null
   }
 }

 static renderDistanceMarkers() {
   let { route, distanceMarkers, distanceLabels, unitLabels } = sources
   const isMetric = store.getters.isMetric
   const unit = isMetric == true ? 'kilometers' : 'miles'
   const unitShort = isMetric == true ? 'km' : 'mi'

   let routeDistance = turf.length(route.features[0], {
     units: unit
   })

   console.log("route line distance", routeDistance)

   routeDistance = Math.floor(routeDistance)
   let points = []

   if(routeDistance >= 1) {
     console.log("route Distance was more than 1")
     // Draw an arc between the `origin` & `destination` of the two points
     //for (var i = 0; i < routeDistance; i += routeDistance / (routeSteps +1)) {
     for (var i = 0; i < routeDistance + 1; i++) {
       let segment = turf.along(route.features[0], i, {
         units: unit
       })

       if (i !== 0) { //Skip the initial point (start coordinates)
         points.push({
           "type": "Feature",
           "properties": {
             'unit': unitShort
           },
           "geometry": {
             "type": "Point",
             "coordinates": segment.geometry.coordinates
           }
         })
       }
     }

     distanceMarkers.features = points
     distanceLabels.features = points
     unitLabels.features = points

     for(var i = 0; i < points.length; i++) {
       distanceLabels.features[i].properties.distance = i + 1 //First one would be 0
     }
     setSourceData('distanceMarkers', distanceMarkers)
     setSourceData('distanceLabels', distanceLabels)
     setSourceData('unitLabels', unitLabels)
   } else {
     console.log("Route length was less than 1 km/mile")
     distanceMarkers.features = []
     distanceLabels.features = []
     setSourceData('distanceMarkers', distanceMarkers)
     setSourceData('distanceLabels', distanceLabels)
   }
 }

 static onMapClick(e) {

  if (MapManager.isInteractionEnabled() && store.getters.isOwnPep && MapManager.isPepEditingEnabled()) {
    console.log("map clicked")
    if(!isRaceEnded()) {
      console.log(e.lngLat)
      let posi = []
      posi[0] = e.lngLat.lng
      posi[1] = e.lngLat.lat

      store.dispatch('addPepPoint', e).then((ref) => {
        console.log("addPepPoint then", ref.key)
        console.log("this")
        console.log(this)
        createGeoJSONCircle(posi, ref.key)
        //createGeoJSONCircle(posi, ref.key)
        store.dispatch('selectPepPoint', ref.key)
        addMarker(ref.key, true)
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}


  static undo() {

    routing.waypoints--
    if (routing.wps.length <= 2) {
      //clear!!
      console.log('poista kaikki')
      updateLength()
      removeMarkerByKey('plotting-first')
      routing = getRoutingInitial()

      if (map.getSource('plotted-route')) {
        map.removeLayer('plotted-route');
        map.removeSource('plotted-route');
      }

    } else {
      routing.coordinates.length = routing.indexes[routing.indexes.length - 2]
      routing.indexes.pop()
      routing.wps.pop()
      addRoute()
    }
    updateLength()

  }

static clearAll() {


  removeMarkerByKey('plotting-first')

  routing = getRoutingInitial()

  if (map.getSource('plotted-route')) {
    map.removeLayer('plotted-route');
    map.removeSource('plotted-route');
  }

  updateLength()


}

static followPaths() {
  routing.followPaths = !routing.followPaths
}

static getPlottedRouteEncoded() {
  let encoded = polyline.encode(routing.coordinates)
  return encoded
}

static getRoutingCoordinatesLength() {
  return routing.coordinates.length
}

 static renderRouteLayer(coords) {

     sources.route.features[0].geometry.coordinates = coords
     setSourceData('route', sources.route)

     sources.start.features[0].geometry.coordinates = coords[0]
     setSourceData('start', sources.start)

     sources.finish.features[0].geometry.coordinates = coords.slice(-1)[0]
     setSourceData('finish', sources.finish)

     // Pass the first coordinates in the LineString to `lngLatBounds` &
     // wrap each coordinate pair in `extend` to include them in the bounds
     // result. A variation of this technique could be applied to zooming
     // to the bounds of multiple Points or Polygon geomteries - it just
     // requires wrapping all the coordinates with the extend method.
     var bounds = coords.reduce(function(bounds, coord) {
       return bounds.extend(coord)
     }, new mapboxgl.LngLatBounds(coords[0], coords[0]))

     map.fitBounds(bounds, {
       padding: 50,
       duration: 0
     })

     // Change the cursor to a pointer when the mouse is over the places layer.
     map.on('mouseenter', 'route', () => {
       map.getCanvas().style.cursor = 'pointer';
     })

     // Change it back to a pointer when it leaves.
     map.on('mouseleave', 'route', () => {
       map.getCanvas().style.cursor = '';
     })

     // When a click event occurs on a feature in the places layer, open a popup at the
     // location of the feature, with description HTML from its properties.
     map.on('click', 'route', this.onMapClick)

 }

 static renderPath(object) {
   console.log("This is renderPath")
   let geoJson
   if(typeof object === 'object') {
    geoJson = object.geoJson
   }
   const race = store.getters.race
   const isMyRaces = store.getters.isMyRaces
   console.log("race", race)
   console.log("isMyRaces", isMyRaces)
   let path

   if(geoJson) {
     path = polyline.toGeoJSON(geoJson)
   } else if(isMyRaces) {
     path = polyline.toGeoJSON(race.data.path.encoded)
   } else {
     path = race.geojson.features[0].geometry
   }

   console.log("path", path)

   if(document.body.contains(document.getElementById('map'))) {
     MapManager.renderRouteLayer(path.coordinates)
   } else {
     console.log("Did not contain map element for routeLayer!")
   }

   if(isMyRaces) {
     this.renderDistanceMarkers()
   }

   if(!isRaceEnded() && isMyRaces) {
     this.renderMarkers()
   }

   store.dispatch('updateRouteRendered', true)
   this.enableInteraction()
   console.log('afafa3')


 }

 static renderMarkers() {
   console.log("renderMarkers")
   const pepPoints = store.getters.race.data.racePepPoints
   for (var key in pepPoints) {
     if (pepPoints.hasOwnProperty(key)) {
       addMarker(key)
     }
   }
 }

 static reRenderMarkers() { //used for draggable enabling/disabling
    this.clearMarkers()
    this.renderMarkers()
 }

 static removePepPoint(key) {
   console.log("removing pepPoint", key)
   store.dispatch('removePepPoint', key)
   removeMarker(key)
 }

 static clearIfRoute() {
   var mapLayer = map.getLayer('route');
   if (typeof mapLayer !== 'undefined') {
     // Remove map layer & source.
     this.clearMap()
   }
 }

 static clearMap() {
   console.log("Clear map mapManager.js")
   store.dispatch('updateRouteRendered', false)
   this.disableInteraction()
   this.clearMarkers()
   this.removeRouteClickListener()
   resetSourceData('route')
   resetSourceData('start')
   resetSourceData('finish')
   resetSourceData('distanceMarkers')
   resetSourceData('distanceLabels')
   resetSourceData('unitLabels')
   resetSourceData('pepRadius')
 }

 static isInteractionEnabled() {
   return mapInteractionHandlers.reduce((isEnabled, nextHandler) => {
     return map[nextHandler].isEnabled() && isEnabled
   }, true)
 }

 static isPepEditingEnabled() {
   let value = pepEditingEnabled
   if (value === false) {
     alert('To edit or add pep points, please click the Add own messages -button on sidebar :)')
   }
   return value
 }

 static enableInteraction() {
   console.log("Enable interaction")
   for (let handler of mapInteractionHandlers) {
     map[handler].enable()
   }

   if(!navigationControl) {
     navigationControl = new mapboxgl.NavigationControl()
   }

   map.addControl(navigationControl, 'top-right')
 }

 static changePepEditingEnabled() {
   pepEditingEnabled = !pepEditingEnabled
   resetSourceData('pepRadius')
   this.reRenderMarkers()
 }

 static renderMap() {

   if(document.body.contains(document.getElementById('map'))) {
   console.log("initMap")
   map = new mapboxgl.Map({
     container: 'map', // container id
     style: 'mapbox://styles/mikkoata/cj6gbhwaz3aa42rp8q3qorxtu', // stylesheet location
     center: [24.78934672689479, 60.18786186951317], // starting position [lng, lat]
     zoom: 15, // starting zoom
     attributionControl: false
   })

   console.log("map", map)
   map.addControl(new mapboxgl.AttributionControl(), 'top-right');

   map.on('load', () => {
     console.log("Map on load")
     this.disableInteraction()

     console.log("sources", sources)
     map.addSource('route', { "type": "geojson", "data": sources.route, "lineMetrics": true })
     map.addSource('distanceMarkers', { "type": "geojson", "data": sources.distanceMarkers })
     map.addSource('distanceLabels', { "type": "geojson", "data": sources.distanceLabels })
     map.addSource('unitLabels', { "type": "geojson", "data": sources.unitLabels })
     map.addSource('start', { "type": "geojson", "data": sources.start })
     map.addSource('finish', { "type": "geojson", "data": sources.finish })
     map.addSource("pepRadius", { "type": "geojson", "data": sources.pepRadius})

     // Blue pep circle
     map.addLayer({
       "id": "pepRadius",
       "type": "fill",
       "source": "pepRadius",
       "layout": {},
       "paint": {
         "fill-color": "#03abc7",
         "fill-opacity": 0.2
       }
     })

     //Route line
     map.addLayer({
       "id": "route",
       "source": "route",
       "type": "line",
       "layout": {
         "line-join": "round",
         "line-cap": "round"
       },
       "paint": {
         'line-width': 8,
         'line-gradient': [
           'interpolate',
           ['linear'],
           ['line-progress'],
           0, "#245eff",
           1, "#0ebf00"
         ]
       },
     })

     //Distance markers
     map.addLayer({
       "id": "distanceMarkers",
       "source": "distanceMarkers",
       "type": "circle",
       'minzoom': 12,
       "paint": {
         "circle-radius": 20,
         "circle-color": "#ffffff"
       }
     })

     //Distance markers
     map.addLayer({
       "id": "distanceLabels",
       "type": "symbol",
       "source": "distanceLabels",
       'minzoom': 12,
       "paint": {
         'text-color': '#000000'
       },
       "layout": {
         'symbol-placement': 'point',
         'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
         //'text-field': '{distance}\n{unit}',
         'text-field': '{distance}',
         'text-offset': [0, -0.35],
         'text-anchor': 'center',
         'text-justify': 'center',
         'text-size': 16,
         'text-allow-overlap': true
         //"icon-allow-overlap": false,
         //"icon-ignore-placement": true
       }
     })

     //unit markers
     map.addLayer({
       "id": "unitLabels",
       "type": "symbol",
       "source": "unitLabels",
       'minzoom': 12,
       "paint": {
         'text-color': '#353942'
       },
       "layout": {
         'symbol-placement': 'point',
         'text-font': ['Asap Regular'],
         'text-field': '{unit}',
         'text-offset': [0, 0.8],
         'text-anchor': 'center',
         'text-justify': 'center',
         'text-size': 12,
         'text-allow-overlap': true
       }
     })

     map.addLayer({
       "id": "start",
       "type": "symbol",
       "source": "start",
       "layout": {
         "icon-image": "start",
         "icon-size": 0.4,
         "icon-allow-overlap": true,
         "icon-ignore-placement": true
       }
     })

     map.addLayer({
       "id": "finish",
       "type": "symbol",
       "source": "finish",
       "layout": {
         "icon-image": "finishline",
         "icon-size": 0.4,
         "icon-allow-overlap": true,
         "icon-ignore-placement": true
       }
     })
   })
  }
  }

  static startPlotting() {
    routing = getRoutingInitial()
    console.log('afafa2')
    this.enableInteraction()
    map.getCanvas().style.cursor = 'pointer'
    map.on('click', this.plotterMapClicked)
  }
  static endPlotting() {
    map.getCanvas().style.cursor = ''
    map.off('click', this.plotterMapClicked)
  }
  static plotterMapClicked(e) {
    let { lng, lat } = e.lngLat
    let coordinate = [lng, lat]
    routing.wps.push(coordinate)
    updateRoute()
  }
  static getLengthString(miles) {

    let unit = (miles ? 'mi' : 'km')
    let multiplier = (miles ? 0.6214 : 1)

    let length = ((routing.length * multiplier) / 1000).toFixed(1)
    if (routing.length === 0) {
      return `Start plotting by clicking the map`
    }
    return `${length} ${unit}`
  }
}

function createGeoJSONCircle(center, pepKey) {
 console.log("createGeoJSONCircle", center, pepKey)
 var points = 64

 var coords = {
   latitude: center[1],
   longitude: center[0]
 };

 var km = 0.05;

 var ret = []
 var distanceX = km / (111.320 * Math.cos(coords.latitude * Math.PI / 180))
 var distanceY = km / 110.574

 var theta, x, y
 for (var i = 0; i < points; i++) {
   theta = (i / points) * (2 * Math.PI)
   x = distanceX * Math.cos(theta)
   y = distanceY * Math.sin(theta)

   ret.push([coords.longitude + x, coords.latitude + y])
 }
 ret.push(ret[0])

 var object = {
   "type": "Feature",
   "geometry": {
     "type": "Polygon",
     "coordinates": [ret]
   }
 }

 radiusObjects[pepKey] = object
 console.log(radiusObjects)

 sources.pepRadius.features.push(object)
 map.getSource('pepRadius').setData(sources.pepRadius)
 console.log(map.getSource('pepRadius'))
}

function updateRoute() {
  console.log('updateRoute called')

  var profile = 'walking'; // Set the profile
  let coords = routing.wps

  console.log(coords)
  var coordsLength = coords.length
  var startCoord = coords[coordsLength - 2]
  var endCoord = coords[coordsLength - 1]
  var coordi = [startCoord, endCoord]
  console.log(coords)
  console.log(coordi)
  // Format the coordinates
  var newCoords = coordi.join(';');
  // Set the radius for each coordinate pair to 25 meters
  var radius = [];
  coordi.forEach((element) => {
    radius.push(50);
  })

  routing.waypoints++
  //  console.log(routing.waypoints)

  let isFirstPoint = (coordsLength === 1)

  if (isFirstPoint) {
    addPlottingMarker(endCoord)
  }

  if (routing.followPaths) {
    if (coordsLength > 1) { //get match only if more than two points!
      getMatch(newCoords, radius, profile);
    }
  } else {
    routing.coordinates.push(endCoord)
    routing.indexes.push(routing.coordinates.length)
    addRoute()

  }

}

/*

function getMatch(coordinates, radius, profile) {
  // Separate the radiuses with semicolons
  var radiuses = radius.join(';');
  // Create the query
  var query =
    'https://api.mapbox.com/directions/v5/mapbox/' +
    profile +
    '/' +
    coordinates +
    '?geometries=geojson&radiuses=' +
    radiuses +
    '&steps=true&access_token=' +
    mapboxgl.accessToken;
*/

function getMatch(coordinates, radius, profile) {
  // Separate the radiuses with semicolons
  var radiuses = radius.join(';');
  // Create the query
  var query =
    'https://api.mapbox.com/directions/v5/mapbox/' +
    profile +
    '/' +
    coordinates +
    '?geometries=geojson' +
    '&steps=true&access_token=' +
    mapboxgl.accessToken;

  console.log(coordinates)

  axios.get(query)
    .then(function (response) {
      // handle success
      let data = response.data
      console.log(response.data);
      if (data.routes.length !== 0) {
      var coords = data.routes[0].geometry;
      // Draw the route on the map
      // routing.coordinates = {...routing.coordinates, coords}
      console.log(coords.coordinates)
      routing.coordinates = routing.coordinates.concat(coords.coordinates)
      routing.indexes.push(routing.coordinates.length)
      //routing.coordinates = [...routing.coordinates, coords.coordinates]
      addRoute()
      } else {
        console.log('not found path')
      }
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })
    .then(function () {
      // always executed
    });

}

function getRoutingInitial() {


  var routingInitial = {
    coordinates: [],
    indexes: [],
    followPaths: true,
    waypoints: 0,
    length: 0,
    wps: []
  }

  return routingInitial

}

function updateLength() {
  if (routing.coordinates.length > 1) {
    let line = turf.lineString(routing.coordinates);
    let length = turf.length(line, { units: 'meters' });
    routing.length = length
    console.log(routing.length)

  } else {
    routing.length = 0
  }
  let event = new Event("plotter-length")
  window.dispatchEvent(event)


}

  function addRoute() {
  console.log(routing.indexes)
  updateLength()

  let coords = {
    'coordinates': routing.coordinates,
    'type': 'LineString'
  }

  let data = {
    'type': 'Feature',
    'properties': {},
    'geometry': coords
  }

  // If a route is already loaded, update its data
  if (map.getSource('plotted-route')) {
    map.getSource('plotted-route').setData(data)
  } else {
    map.addLayer({
      'id': 'plotted-route',
      'type': 'line',
      'source': {
        'type': 'geojson',
        'data': data
      },
      'layout': {
        'line-join': 'round',
        'line-cap': 'round'
      },
      'paint': {
        'line-color': '#03AA46',
        'line-width': 8,
        'line-opacity': 0.8
      }
    });
  }
}

function addMarker(key, selected) {
   const race = store.getters.race
   const pepPoint = race.data.racePepPoints[key]

   console.log("MapManager addMarker!")
   var marker
   const isEventEdit = store.getters.isEventEdit
   if(pepPoint.runnerPoint || isEventEdit) {
     const { longitude, latitude } = pepPoint.location
     if (isRaceEnded()) {
       //uneditable (friend marker)
       marker = addNormalMarker('runner', pepPoint, key)
     } else {
       marker = addEditableMarker('runner', pepPoint, key, selected)
     }

     const coords = [ longitude, latitude ]
     createGeoJSONCircle(coords, key)

   } else {
     if (isRaceEnded()) {
       marker = addNormalMarker('friendAfter', pepPoint, key)
     } else {
       marker = addNormalMarker('friendBefore', pepPoint, key)
     }
   }

   markers[key] = marker

 }

 function addNormalMarker(type, pep, key) {
   var el = document.createElement('div')
   el.classList.add('marker', type)

   var pepMessage = pep.messagetype == 'A' ? 'Audio message' : pep.message
   var sender = pep.sender ? pep.sender : 'Your point'

   el.addEventListener('click', (e) => {
     console.log("normal pep click")
     console.log(el)

     if (isRaceEnded()) {
       if(popup) {
         popup.remove()
       }

       popup = new mapboxgl.Popup({
           closeButton: false
         })
         .setLngLat([pep.location.longitude, pep.location.latitude])
         .setDOMContent(popupVue.$el)
         .addTo(map)

       popupVue.pep = pep
       popupVue.pepKey = key
       popupVue.popup = popup
     } else {
       console.log("Race has not ended")
     }

     e.stopPropagation()

   })

   return new mapboxgl.Marker(el)
     .setLngLat([pep.location.longitude, pep.location.latitude])
     .addTo(map)
 }

 function addPlottingMarker(coordinate) {
   let key = 'plotting-first'

   var el = document.createElement('div')
   el.classList.add('marker', 'waypoint')

   markers[key] = new mapboxgl.Marker(el)
     .setLngLat(coordinate)
     .addTo(map)
 }

 function addEditableMarker(type, pep, key, selected) {
   const setSelected = selected | false
   console.log('editoitava !')
   var el = document.createElement('div')
   if (setSelected) {
     el.classList.add('marker', 'runner-editable')
     selectedMarkerDiv = el

   } else {
     el.classList.add('marker', 'runner')
   }

   el.addEventListener('click', (e) => {
     e.stopPropagation(); //Stop the click even from the route's onclick listener

     if (!isRaceEnded()) {
       if(MapManager.isInteractionEnabled() && MapManager.isPepEditingEnabled()) {
         store.dispatch('selectPepPoint', key)

         if (selectedMarkerDiv !== null) {
           selectedMarkerDiv.classList.remove('runner-editable')
           selectedMarkerDiv.classList.add('runner')
         }

         el.classList.remove('runner')
         el.classList.add('runner-editable')

         selectedMarkerDiv = el

       }
     } else {
       alert("race has ended, cannot edit")
     }
   })

   return new mapboxgl.Marker(el, { draggable: pepEditingEnabled })
     .setLngLat([pep.location.longitude, pep.location.latitude])
     .on('dragend', (e) => {
       onDragEnd(e, key)
     })
     .on('dragstart', (e) => {
       onDragStart(e, key)
     })
     .addTo(map)
 }

 function onDragStart(e, key) {
   removeGeoJSONCircle(key)
 }

 function removeGeoJSONCircle(pepKey) {
   console.log("removeGeoJSONCircle", pepKey)

   radiusObjects = _.omit(radiusObjects, pepKey) // Remove pep point's circle from the object

   let newCircles = []
   Object.keys(radiusObjects).forEach(key => {
     newCircles.push(radiusObjects[key])
   })

   sources.pepRadius.features = newCircles
   setSourceData('pepRadius', sources.pepRadius)
 }

 function resetSourceData(type) {
   let source = sources[type]
   if(type == 'route' || type == 'start' || type == 'finish') {
     source.features[0].geometry.coordinates = []
   } else {
     source.features = []
   }
   setSourceData(type, source)
 }

 function setSourceData(type, data) {
   map.getSource(type).setData(data)
 }

 function onDragEnd(e, key) {
  const latitude = e.target._lngLat.lat
  const longitude = e.target._lngLat.lng

  const location = { latitude, longitude }
  const obj = { coords: location, key: key }

  store.dispatch('updatePepCoords', obj).then(() => {
    createGeoJSONCircle([location.longitude, location.latitude], key)
  }).catch((err) => console.log(err))
 }

 function removeMarker(key) {
    markers[key].remove()
    //this.markers = _.omit(this.markers, [key])
    delete markers[key]
    removeGeoJSONCircle(key)
  }

function removeMarkerByKey(key) {
  if (markers.hasOwnProperty(key)) {
    console.log('deleting marker')
    markers[key].remove()
    delete markers[key]
  }
}

export default MapManager
